// extracted by mini-css-extract-plugin
export default {"inputWrapper":"PostCodeInput_inputWrapper__JT84l","input":"PostCodeInput_input__DFIbj","daumPostCode":"PostCodeInput_daumPostCode__Uvxty"};